'use strict';
module.exports = require('./DeferredContent.vue');